import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PublishArticle from './pages/PublishArticle';
import Articles from './pages/Articles';
import ReviewArticles from './pages/ReviewArticles';
import Ads from './pages/Ads';
import Moderation from './pages/Moderation';
import Analytics from './pages/Analytics';
import Settings from './pages/Settings';
import ManageCategories from './pages/ManageCategories';
import ManageLocations from './pages/ManageLocations';
import Manage from './pages/Manage';
import Comments from './pages/Comments';
import Users from './pages/Users';
import Admins from './pages/Admins';
import Contributors from './pages/Contributors';
import ContributorReview from './pages/ContributorReview';
import ContributorEarnings from './pages/ContributorEarnings';
import Withdrawals from './pages/Withdrawals';
import Partners from './pages/Partners';
import PartnerInstalls from './pages/PartnerInstalls';
import PartnerPayouts from './pages/PartnerPayouts';
import PartnerAnalytics from './pages/PartnerAnalytics';
import ArticleEngagementDetails from './pages/ArticleEngagementDetails';
import StatusManager from './pages/StatusManager';
import QuotesManager from './pages/QuotesManager';
import './App.css';

function PrivateRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to="/login" />;
}

function AppRoutes() {
  const { isAuthenticated } = useAuth();

  return (
    <Routes>
      <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="articles/new" element={<PublishArticle />} />
        <Route path="articles" element={<Articles />} />
        <Route path="articles/engagement/:id" element={<ArticleEngagementDetails />} />
        <Route path="review-articles" element={<ReviewArticles />} />
        <Route path="contributors" element={<Contributors />} />
        <Route path="contributor-earnings" element={<ContributorEarnings />} />
        <Route path="contributor-review" element={<ContributorReview />} />
        <Route path="withdrawals" element={<Withdrawals />} />
        <Route path="partners" element={<Partners />} />
        <Route path="partner-installs" element={<PartnerInstalls />} />
        <Route path="partner-payouts" element={<PartnerPayouts />} />
        <Route path="partner-analytics" element={<PartnerAnalytics />} />
        <Route path="ads" element={<Ads />} />
        <Route path="status" element={<StatusManager />} />
        <Route path="quotes" element={<QuotesManager />} />
        <Route path="comments" element={<Comments />} />
        <Route path="moderation" element={<Moderation />} />
        <Route path="analytics" element={<Analytics />} />
        <Route path="manage-categories" element={<ManageCategories />} />
        <Route path="manage-locations" element={<ManageLocations />} />
        <Route path="manage" element={<Navigate to="/manage-categories" replace />} />
        <Route path="settings" element={<Settings />} />
        <Route path="admins" element={<Admins />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" toastOptions={{
          style: { background: '#1a1a1a', color: '#fff', borderRadius: '10px' },
        }} />
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
